module.exports = __webpack_public_path__ + "img/alert-circle.e5eb9bdd.svg";